const translations = {
    1: 'A popup window was blocked by your browser.\nTo have this site fully functional, you will have to deactivate popup blocker software\nor to configure them to allow popup windows created by this site.',
    2: "Please include the '@' symbol, the email address should look similar to this: myname@myisp.com",
    3: 'Spaces in the email address are not allowed, the email address should look similar to this: myname@myisp.com',
    4: "You have more than one '@' symbol. The email address should look like this: myname@myisp.com",
    5: 'The email address is too short. The email address should look similar to this: myname@myisp.com',
    6: 'The domain part of the email address is too short. The email address should look similar to this: myname@myisp.com',
    7: 'The domain name in the email address is invalid. The email address should look similar to this: myname@myisp.com',
    8: 'The contents have been copied to your clipboard.\t\n',
    9: 'Please enter your payment card number.',
    10: 'Your payment card has expired, or the expiry date you have chosen is incorrect.',
    11: 'CVV is the 3 digit code on the back of your card.',
    12: 'The CVV you entered is incorrect.',
    13: 'Please choose your preferred method of payment',
    14: 'Please choose your preferred payment frequency',
    15: 'The earnings must be at least %s',
    16: 'Please enter the name of the person to appear on checks',
    17: 'Please enter your address',
    18: 'Please enter your city',
    19: 'Please enter your state/province or similar',
    20: 'Please enter your zip code/postcode',
    21: 'Please enter your Western Union agent address',
    22: 'Please enter a beneficiary name for bank transfers',
    23: "Please enter the bank's name",
    24: "Please enter the bank's location",
    25: "Please enter the bank's country",
    26: 'Please enter the bank account number',
    27: 'Please enter the bank clearing code',
    28: 'Please enter your contact name',
    29: 'The email address is not valid. The email address should look similar to this: myname@myisp.com',
    30: 'You must supply a name for each individual.',
    31: "You have included a space or other invalid character in the individual's name.",
    32: "You must specify this individual's gender.",
    33: "You must specify this individual's sexual orientation.",
    34: 'You must specify at least one language spoken by this individual.',
    35: 'Too many languages specified. Max allowed is %s per individual.',
    36: 'Specify at least one Individual.',
    37: 'Describe why you enjoy being a Chathost.',
    38: 'Specify when it will be possible for viewers to catch you.',
    39: 'Describe what viewers can expect from your show.',
    40: 'Please mention your Turn-Offs.',
    41: 'Please mention your Turn-Ons.',
    42: 'The password must be at least 6 characters long (no spaces) and different from your screen name.',
    43: 'The entered passwords must match.',
    44: 'Your screen name must be at least 6 characters long (no spaces or punctuation).',
    45: 'You must select your country of residence.',
    46: 'You must enter a state if you are from the US or Canada.',
    47: 'Please enter your zip or postal code.',
    48: 'Please enter your city of residence.',
    49: 'Please enter your address.',
    50: 'Please enter your last name.',
    51: 'Please enter your first name.',
    52: "Selecting country as Private will reduce your appearance in 'Chathost search' results. Continue?",
    53: 'You must confirm that you have read and fully accepted the &quot;Terms and Conditions&quot;.',
    54: 'The entered emails must match.',
    55: 'Please click on one of the options before continuing.',
    56: 'Please supply an existing ScreenName and password.',
    57: 'Please fill in all the scores.',
    58: 'Please provide the "other" reason.',
    59: 'Expand list :',
    60: 'Collapse list: ',
    61: 'Invalid post code.',
    62: 'US Zip codes must be of the following format 12345 or 12345-1234.',
    63: 'Please select the state in which you reside.',
    64: 'The state you select must match the country you selected.',
    65: 'Please select a valid date of birth.',
    66: 'You must be 18+ to become a member.',
    67: 'Payment card numbers must contain only numbers',
    68: 'Please enter the first column of the check numbers at the bottom of your german ID card.',
    69: "Please enter the first column of the check numbers (10 digits and letter 'D') exactly as it appears on your ID card.",
    70: 'Please enter the second column of the check numbers at the bottom of your german ID card.',
    71: 'Please enter the second column of the check numbers (7 digits) exactly as it appears on your ID card.',
    72: 'Please enter the third column of the check numbers at the bottom of your german ID card.',
    73: 'Please enter the third column of the check numbers (7 digits) exactly as it appears on your ID card.',
    74: 'Please enter the fourth column of the check numbers at the bottom of your german ID card.',
    75: 'Please enter the fourth column of the check numbers (1 digit) exactly as it appears on your ID card.',
    76: 'Please select your bank.',
    77: 'Please select your bank country.',
    78: 'Please enter your bank code.',
    79: 'Your bank code may contain no more than 8 digits and spaces.',
    80: 'Please enter your account number.',
    81: 'Your account number may contain no more than 10 digits and spaces.',
    82: 'Incorrect payment card number. Please try again.',
    83: 'Wrong payment card type.',
    84: 'The number of digits must total %s for %s.',
    85: 'The %s prefix must be %s.',
    86: 'The payment card checksum process indicated that the card number entered is incorrect.',
    87: "Your screen name must be between 4 and 15 characters long, can't contain spaces or punctuation and can't be entirely numeric.",
    88: "Your password must be between 6 and 15 characters long, can't contain non latin symbols and must be different from your screen name.",
    89: 'Please tell us how your found us.',
    90: "Please enter the payment card holder's name (exactly as on card)",
    91: 'ID card number invalid: Check sum failed.',
    92: 'Please enter a valid ID for ePassporte.',
    93: 'There is a problem with your password. It must include AT LEAST 6 characters and cannot include any spaces. It must be different from your screen name.',
    94: 'There is a problem with your admin password. It must include AT LEAST 6 characters and cannot include any spaces.',
    95: 'There is a problem with your owner password. It must include AT LEAST 6 characters and cannot include any spaces.',
    200: 'Are you sure you want to start a FREE video session?',
    201: 'You must choose an Individual Chathost',
    202: 'You must enter a title for this session',
    203: 'You must enter a valid IP address',
    204: 'Session Price for *%s* category should be between %s and %s',
    205: 'Do you want to start a CHARGEABLE video session?',
    206: 'You must enter your private code!',
    210: 'Are you sure that you want to end this session?',
    211: 'Doing so you will end this session.',
    212: 'You need to accept to participate in Strip Games',
    213: 'You need to charge in order to participate in Strip Games',
    214: 'Please select at least 3 items of clothing',
    215: 'Please select a maximum of 6 items of clothing',
    216: 'Panties are required!\nPlease select them.',
    217: 'January|February|March|April|May|June|July|August|September|October|November|December',
    218: 'Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec',
    219: 'Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday',
    220: 'Sun|Mon|Tue|Wed|Thu|Fri|Sat',
    221: 'Please enter country payment card issued',
    222: 'Oops, you forgot to enter your payment card number.',
    223: 'Oops, you forgot to choose the expiry date.',
    224: 'Your payment card has expired, or the expiry date you have chosen is incorrect.',
    225: 'Oops, you forgot to enter your e-mail address.',
    226: 'Oops, you forgot to confirm your e-mail address.',
    227: 'Your entered different e-mail addreses.',
    228: 'Please enter chathost screenname.',
    229: 'Please enter promotion code.',
    230: ' PREVIOUS ',
    231: ' NEXT ',
    232: ' View %s profile',
    233: ' You can also hear *%s* ',
    234: 'Click on picture to log in',
    235: 'Click on picture to enlarge',
    236: ' cannot be selected together with ',
    237: 'Please select prepayment amount.',
    238: 'Oops, you forgot to enter your screen name.',
    239: ' Free Live Chat with %s',
    240: 'Visa card has 13 or 16 digits.',
    241: 'Master Card has 16 digits.',
    242: 'Payment Card is not supported. Visa or MasterCard only.',
    243: 'Screen Name already exists. Please choose another one.',
    244: 'Please enter screen name (alphanumeric 4-15 chars long).',
    245: 'Please type the Screen Name in the below form.',
    246: 'New password must be different than the current password.',
    247: 'Please type your current password.',
    248: 'Please type your new password.',
    249: 'The password must be at least %s characters long.',
    250: 'The password must be not longer than %s characters.',
    251: 'The expiry date you have chosen is incorrect.',
    252: 'Do you really want to reset the form?',
    253: 'Do you really want to delete this message?',
    254: 'You cannot add any more files to this message',
    255: 'You cannot attach files to a message addressed to yourself',
    256: 'It is not possible to upload file!',
    257: 'Do you really want to delete this attachment?',
    258: 'The subject you have entered is too long',
    259: 'You cannot send empty messages',
    260: 'Your message is too long',
    261: 'Screen name you have entered is too long',
    264: 'Your Chathost payout increase for One2One sessions is too low.',
    265: 'Your Chathost payout increase for One2One sessions is too high.',
    300: "The Screen Name must be alphanumeric between %s and %s characters long, can't contain spaces or punctuation and can't be entirely numeric.",
    301: "The password must be between %s and %s characters long, can't contain non latin symbols and must be different from your Screen Name.",
    302: 'Invalid phone format. Please enter a valid phone.',
    400: 'Unknown error: %s',
    401: 'Tell everyone why you enjoy CamContacts! Let Viewers know what your personality is like. Be creative, fun and interesting!',
    402: 'Let Viewers know what you enjoy doing in life and what kind of people you like to meet here. Flirting is highly recommended!',
    403: 'Let Viewers know what they can expect in your shows. Be as honest and detailed as possible.',
    404: "Tell Viewers what you don't like! Rude people? Being lonely?",
    405: 'Please select the languages that are fluent and conversational for you.  And please be honest!',
    406: 'Please check all that apply.',
    407: 'Please check all that apply. Be as complete and honest as possible. This helps us determine how to present you in search results.',
    408: 'If you have your own website and would like to let CamContacts members know about it then put the URL of your website here.',
    409: 'When to Catch Me/Us on-line<br>(e.g. 20:00 to 23:00 ET, whenever possible)',
    410: 'There was a technical problem processing your profile.\nPlease contact Customer Support in order to solve it.',
    411: 'not defined',
    412: 'Create Your Personal Profile',
    413: 'no description available',
    414: 'Type input #%s is not implemented yet',
    415: 'typeID #%s is not defined',
    416: 'remove',
    417: 'Remove "%s"?',
    418: 'Error: gay option is not available for female',
    419: 'Error: lesbian option is not available for male',
    420: 'type.input #%s is not used here',
    421: 'You must add at least one individual to continue',
    422: 'Please come back when you are over 18, or please set your real age',
    423: 'Please enter your name',
    424: 'Please choose your gender',
    425: 'Please choose your sexual orientation',
    426: 'Please enter correct date of birth',
    427: 'Please choose a category',
    428: 'Please choose an adult rating',
    429: 'Please choose your ethnic origin',
    430: 'Please choose your build',
    431: 'Please choose your hair color',
    432: 'Please choose your hair length',
    433: 'Please choose your eye color',
    434: 'Please choose your body hair type',
    435: 'Please choose your dick size',
    436: 'Please choose your bust size',
    437: 'Please choose your scene',
    438: 'Please choose your role',
    439: 'Please describe why you are here',
    440: 'Please describe what viewers can expect from you',
    441: 'Please describe what turns you on',
    442: 'Please describe what turns you off',
    443: 'Please choose the languages you speak',
    444: 'Please describe your schedule',
    445: 'Please enter valid homepage URL',
    446: 'Are you sure you want to set profile as verified?',
    447: 'You can not change your category/adult level or add new individuals while you are online.\nPlease end the session first and try again.',
    448: '<table class="table"><thead><tr><th>Size</th><th>Overbust measurement in centimeters and (inches)</th><th>Cup Size</th></tr></thead><tbody><tr><td>S</td><td>76 - 86 (30-34)</td><td>A-B</td></tr><tr><td>M</td><td>86 - 94 (34-37)</td><td>B-C</td></tr><tr><td>L</td><td>94 - 102 (37-40)</td><td>C-D</td></tr><tr><td>XL</td><td>102 - 109 (40-43)</td><td>D-E</td></tr><tr><td>XXL</td><td>109 - 130 (42-51)</td><td>E-H</td></tr></tbody></table>',
    449: 'According to most surveys, the great majority of penises measure between 15cm and 18cm (6-7 inches) when erect, with the average figure being about 16.5cm (6.5 inches). So if 16.5 cm is "medium," you can take it from here, guys. Please try to be honest ,-)',
    450: 'Please check all that apply.  This will help us present you in search results for Viewers looking for specific attributes.',
    451: 'Do you have any special fetishes you are into?  Please check all that apply.  This will help us present you in search results for Viewers looking for detailed show specifications.',
    452: 'Do you like to be on top or on the bottom, or does it change based on your mood? Please check all that apply.',
    453: 'Maybe you are a big cuddly, hairy man (commonly known as a "bear")? Or maybe a young man with a slender build and little or no body hair (also known as a "twink")? Or maybe you are muscular or into leather? Or perhaps you are a "Daddy," an older gay man looking for a younger man? Whatever your preference, please check all that apply.',
    454: "Your build is pretty obvious so be honest! And if you don't know what BBW means, it refers to Big Beautiful Woman, or women who are above the average weight. Also petite means small. So your height is under 159cm AND you wear a dress size of 32-36 (European), 2-6 (US) or 4-8 (UK) then you are considered petite",
    455: 'You can not create your personal profile while you are online.\nPlease end the session first and try again.',
    456: 'You are under 18! Please check your date of birth',
    457: 'Please upload a copy of your ID<ul><li>Do not cover up any of the details on the ID</li><li>Ensure all details are clear and not blurred</li></ul>',
    458: 'The file must either be: JPG, JPEG, PNG or GIF format',
    459: 'Please upload a copy of your ID',
    460: 'Document Details',
    461: 'Personal details',
    462: 'The documents submitted are not of sufficient quality. It is important that you follow the guidelines outlined in the box below.',
    463: 'Under various circumstances we need an additional ID from you. This may be due to your age, location, name or simply a quality check. You can send us any of the documents in the drop down list. Please do not send the same document again, this will only delay your registration.',
    464: 'Format',
    465: 'File to upload',
    466: 'Face and Document file',
    467: 'Please upload a high quality copy of you holding your ID next to your face. Both your face and at least 3 sides of the ID must be visible.',
    468: 'The ID scan and face + ID picture both have the same government issued document',
    469: 'The ID belongs to the person holding it',
    470: 'Do not cover up any of the details on the ID',
    471: 'Both your face and ID are clear and in focus',
    472: 'Three or more edges of the ID are visible',
    473: 'The data in the ID is readable',
    474: 'Please upload your Face and ID document',
    475: 'Additional Document',
    476: '<b>Beneficiary Name</b><br>This is the name of the bank account holder (this may be different from your name).',
    477: '<b>What is an IBAN?</b><br>An IBAN is an international account number standard. All banks in Europe Israel, Kazakhstan, Lebanon, Mauritania, Mauritius, Saudi Arabia, Tunisia and Turkey use IBAN (exceptions include Russia, Belarus, Ukraine, Armenia and Azerbaijan these countries do not use IBAN). The format of an IBAN by country can be found <a href="https://en.wikipedia.org/wiki/International_Bank_Account_Number" target="_blank" rel="nofollow external noopener noreferral"><b>here</b></a>.',
    478: "<b>What is a SWIFT/BIC?</b><br>SWIFT/BIC is a standard format of Bank Identifier Codes, which tells us the Bank Name and Address. A SWIFT/BIC is 8 or 11 characters:<br><br>4 letters: Institution Code<br>2 letters: country code<br>2 letters or digits: location code<br>3 letters or digits: branch code, optional ('XXX' for primary office)",
    479: '<b>What is a Correspondenting Bank?</b><br>We pay in USD. Some local/domestic banks do not have capabilities to accept USD transactions therefore they use a partner i.e. a correspondenting bank, to do this. Please ask your bank for the Correspondenting Bank Name, Code/SWIFT, and Account Number',
    480: 'Please enter your name in your local language',
    481: 'Please fill in your name',
    490: 'Zoom is not available for HD pictures',
    491: 'This chathost is currently offline',
    500: 'Are you sure you want to switch to One2One',
    501: 'Are you sure you want to switch to HiLo',
    502: 'Unable to switch session',
    510: 'Very Bad',
    511: 'Bad',
    512: 'Satisfactory',
    513: 'Good',
    514: 'Very Good',
    515: 'Rate for',
    520: 'Please choose your title.',
    521: 'Please choose your nationality.',
    522: 'Please choose your day of birth.',
    523: 'Please choose your month of birth.',
    524: 'Please choose your year of birth.',
    525: 'Please enter expiry month',
    526: 'Please enter expiry year',
    527: 'Please enter expiry date',
    530: 'Error. Please, try later...',
    540: 'Amount is not selected',
    541: 'Card is not selected',
    542: 'Error: selected card is not defined',
    543: 'credits',
    544: 'failed',
    545: 'expired',
    546: 'new card',
    547: 'valid',
    548: 'Card is expired',
    549: 'Please wait...',
    550: 'Error: amount is not in the list',
    551: 'Error: card is not in the list',
    560: 'Please type your email address',
    561: 'Email address is not valid',
    562: 'Please type a subject',
    563: 'Please enter a message',
    564: 'Please enter the Help Request ID',
    570: 'OpenSessions',
    571: 'Open session',
    572: 'One2One',
    573: 'Private One2One session',
    574: 'Strip HiLo',
    575: 'One2One - Strip HiLo',
    576: 'clothes.',
    577: 'Unknown Session Type:',
    578: 'Begin',
    580: 'There was an error on this page.',
    581: 'Error',
    582: 'URL',
    583: 'Line',
    584: 'Click OK to continue.',
    590: 'Error! Not enough function arguments',
    591: 'excluding the string',
    592: 'for the number of substitution parameters in string',
    593: 'so far',
    600: 'This is a private session.\r\nYou must enter the private Access Code given to you by the ChatHost!',
    601: 'If you can see this message for more than a few seconds the camera is probably not running.',
    602: 'Close Window',
    610: 'Sorry, requested content could not be loaded',
    611: 'Please try later',
    620: 'Error: No image was captured. Take a new snapshot and try again.',
    621: 'Error: Unable to upload the image, please try again in few minutes.',
    622: 'Error: Could not find any camera available.',
    623: 'Snapshot taken. You may now save the snapshot to your photo archive, or take a different snapshot.',
    624: 'Snapshot saved in your photo archive.',
    625: 'Please allow access to your camera..',
    626: 'Taking snapshot',
    627: 'Taking snapshot in %s seconds.',
    628: 'Application error, please restart your browser and try again.',
    629: 'Saving image, please wait...',
    630: 'Drag and drop files here.',
    631: 'Files detected, drop them here!',
    632: "Hasn't started yet",
    633: 'Done!',
    634: 'Total uploaded: ',
    635: 'Upload complete!',
    636: 'We are sorry, but in order to use the uploader, you need a browser that support HTML5 or have the Flash player installed.',
    637: 'Error: Unable to upload the photo.',
    638: 'Error: Unable to upload the photo - %s',
    700: 'Error: No URL provided. Nothing to load.',
    701: '<b>%s</b> was removed from Your Favorites',
    702: '<b>%s</b> added to Your Favorites and Alert set',
    703: '<b>%s</b> added to Your Favorites',
    704: 'Memo for <b>%s</b> saved',
    705: 'Error: Network problem occured. Please, try again.',
    706: 'This video session has been password protected by the Chathost. To enter this session you require the correct password.',
    707: 'Confirmation ID and Password are required',
    708: 'Age must be a number from 18 until 99!',
    709: 'Please enter date of birth',
    710: 'Screen Name and Password are required',
    711: 'You need to agree to the Terms and Conditions before you can login',
    712: 'Screenname already exists. Please input or choose another one.',
    800: 'Unsupported image file format! Supported image file formats are "JP(E)G, GIF"',
    801: 'There was an error while processing image. Please try again.',
    802: 'Image file limit reached! Max limit - 3 images.',
    803: 'File size is bigger than maximum allowed size - 20Mb',
    804: 'Attachment <b>%s</b> uploaded.',
    805: 'Corrupt or broken image file! Please choose another image file and try again.',
    900: 'Image cannot be found.',
    901: 'Failed to load image.',
    902: 'Previous picture',
    903: 'Next picture',
    904: 'Switched to <b>%s</b> album',
    905: 'Screen name required',
};

if (typeof window !== 'undefined') {
    window.translations = translations;
}

export default translations;
